module.exports = __webpack_public_path__ + "img/3.b8c1d02e.webp";